$(document).ready(function () {
  // 当鼠标悬停在主导航项上时，重置下拉菜单状态
  $(".site-nav, .site-nav__item").mouseenter(function () {
    // 找到可能出现的下拉菜单
    let $dropdown = $(this).find(".site-nav__dropdown");

    if ($dropdown.length > 0) {
      // 重置左侧菜单选中状态 - 选中第一个
      $dropdown
        .find(".site-nav_childrenlink")
        .removeClass("current-childrenlink");
      $dropdown
        .find(".site-nav_childrenlink:first")
        .addClass("current-childrenlink");

      // 重置右侧标题 - 显示第一个，隐藏其他
      $dropdown.find(".mega-menu-right-header-text").addClass("hide");
      $dropdown.find(".mega-menu-right-header-text:first").removeClass("hide");

      // 重置右侧内容 - 显示第一个，隐藏其他
      $dropdown.find(".mega-menu-grandchildlinks").addClass("hide");
      $dropdown.find(".mega-menu-grandchildlinks:first").removeClass("hide");
    }
  });

  $(".site-nav_childrenlink").hover(function () {
    // 获取当前点击元素所在的mega menu容器
    let $megaMenu = $(this).closest(".site-nav__dropdown");
    let index = $(this).index();
    $(this)
      .addClass("current-childrenlink")
      .siblings()
      .removeClass("current-childrenlink");
    // 切换右侧标题的显示
    $megaMenu
      .find(".mega-menu-right-header-text")
      .eq(index)
      .removeClass("hide")
      .siblings(".mega-menu-right-header-text")
      .addClass("hide");

    // 切换右侧内容的显示
    $megaMenu
      .find(".mega-menu-grandchildlinks")
      .eq(index)
      .removeClass("hide")
      .siblings(".mega-menu-grandchildlinks")
      .addClass("hide");
  });

  // 移动端进入三级菜单
  $(".js-drawer-open-subdrawer").click(function(e) {
    const $link = $(this).find('a');
    if ($link.hasClass('has-sub-menu')) {
        e.preventDefault();
    }
    var dataTitle = $(this).data("menu-title");
      // var target = event.target;
      // console.log('target', target);
    var drawerList = document.querySelectorAll('.mobile-nav-subdrawer')
    drawerList.forEach(el => {
      if (el.id.includes(dataTitle)) {
        theme.utils.prepareTransition(el, function() {
          el.classList.add('sub-drawer--is-open');
        })
      }
    })
    
    // if ($(this).hasClass("has-sub-menu")) {
    //   // 阻止默认的跳转行为
    //   event.preventDefault();

    //   var dataTitle = $(this).data("menu-title");
    //   var target = event.target;
    //   console.log('target', target);
    //   var drawerList = document.querySelectorAll('.mobile-nav-subdrawer')
    //   drawerList.forEach(el => {
    //     if (el.id.includes(dataTitle)) {
    //       theme.utils.prepareTransition(el, function() {
    //         el.classList.add('sub-drawer--is-open');
    //       })
    //     }
    //   })
      
      // $("div.mobile-nav-subdrawer").each(function() {
      //   // 获取div的id属性
      //   var divId = $(this).attr("id");
        
      //   if (divId && divId.indexOf(dataTitle) !== -1) {
      //     prepareTransition2(target, function() {
      //       target.classList.add("sub-drawer--is-open");
      //     })
      //   }
      // });
    // }
  });
  // 移动端返回上级菜单
  $(".mobile-nav-subdrawer-back").click(function() {
    var drawer = document.querySelector('.mobile-nav-subdrawer.sub-drawer--is-open');
    theme.utils.prepareTransition(drawer, function() {
      drawer.classList.remove('sub-drawer--is-open')
    })
    // $(".mobile-nav-subdrawer.sub-drawer--is-open").removeClass("sub-drawer--is-open");
  })

  window.on('click', function(evt) {
    // Check if the click is inside the drawer
    if (!evt.target.closest('.drawer')) {
      var drawer = document.querySelector('.mobile-nav-subdrawer.sub-drawer--is-open');
      if (!drawer) {return;}
      theme.utils.prepareTransition(drawer, function() {
        drawer.classList.remove('sub-drawer--is-open')
      })
    }
    return;
  });

  //loloyal
  function addHashFragment(url) {
    const fragment = "#loloyal-home";
    
    // 检查URL是否已经包含该片段
    if (url.indexOf(fragment) === -1) {
      // 如果URL已有其他片段，先移除它
      const baseUrl = url.split('#')[0];
      return baseUrl + fragment;
    }
    
    // 如果已经有该片段，直接返回原URL
    return url;
  }

  $(".loloyal").click(function() {
    let currentUrl = window.location.href;
    let newUrl = addHashFragment(currentUrl);
    window.location.href = newUrl;
  })

  // 更新免邮
  document.addEventListener('cart:reloaded', function(event) {
    const freeShippingBars = document.querySelectorAll('.free-shipping-bar');
    if (freeShippingBars.length === 0) {
      return;
    }
    var subtotal = event.detail.subtotal;
    freeShippingBars.forEach((bar, index) => {
      const freeShippingAmount = parseFloat(bar.dataset.freeShippingAmount) || 0;
      // 计算免邮费进度 (0-1之间)
      const progress = Math.min(Math.max(subtotal / freeShippingAmount, 0), 1);
      
      // 计算还差多少钱
      const difference = Math.max(freeShippingAmount - subtotal, 0);
      updateProgressBar(bar,progress)
      updateMessage(bar, progress, difference)
    });
    function updateProgressBar(bar, progress) {
      // 更新 CSS 变量
      bar.style.setProperty('--free-shipping-progress', progress.toString());
      
      // 更新数据属性
      bar.setAttribute('data-free-shipping-progress', progress === 1 ? '1' : progress.toString());
    }
    function updateMessage(bar, progress, difference) {
      const messageNo = bar.querySelector('.free-shipping-bar__message--no');
      const messageYes = bar.querySelector('.free-shipping-bar__message--yes');
      const differenceElement = bar.querySelector('#free-shipping-difference');
      
      if (progress >= 1) {
          // 已达到免邮费条件
          if (messageNo) messageNo.style.display = 'none';
          if (messageYes) messageYes.style.display = 'inline';
      } else {
          // 未达到免邮费条件
          if (messageNo) messageNo.style.display = 'inline';
          if (messageYes) messageYes.style.display = 'none';
          
          // 更新还差多少钱的显示
          if (differenceElement) {
              differenceElement.innerHTML = theme.Currency.formatMoney(difference, theme.settings.moneyFormat);
          }
      }
    }
  });
  
});
